/** US-wide static bounds — returns ALL clusters for the user's locations */
export const US_BOUNDS: google.maps.LatLngBoundsLiteral = {
  north: 55,
  south: 20,
  east: -60,
  west: -130,
};
